<h1 mat-dialog-title>Your account is updated</h1>
<div mat-dialog-content>
  <p>You can now login to your account using the information provided.</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button id="dialogActivateLoginButton"
    color="primary" 
    [mat-dialog-close]="true" 
    cdkFocusInitial>Login</button>
</div>